import { env } from "@/web/lib/env";

const CONVERSATION_VIDEO = `${env.VITE_WITHCO_IMAGE_CDN_BASE}/ohanian-conversation.mp4`;

/** Safari won't paint a video frame from preload alone; ImageKit extracts this still. */
const CONVERSATION_POSTER = `${env.VITE_WITHCO_IMAGE_CDN_BASE}/ohanian-conversation.mp4/ik-thumbnail.jpg`;

/**
 * Full-bleed red feature for the founder interview: a yellow headline over a
 * white-framed video player.
 */
export function AboutConversation() {
  return (
    <section className="w-full bg-withus-red px-6 py-20 md:px-12 md:py-28">
      <div className="mx-auto flex max-w-[843px] flex-col items-center gap-10">
        <video
          src={CONVERSATION_VIDEO}
          poster={CONVERSATION_POSTER}
          controls
          playsInline
          preload="metadata"
          className="aspect-843/498 w-full bg-withus-pure-white object-cover shadow-withus-default"
        >
          Kevin Song in conversation with Alexis Ohanian
        </video>
      </div>
    </section>
  );
}
